import { apiClient } from "@shared/lib/api/client";

export interface SidebarPreferences {
  hiddenGroups: string[];
}

const SIDEBAR_PREFERENCES_ENDPOINT = "/api/v1/profile/me/sidebar-preferences/";
const SIDEBAR_GROUP_KEY_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function getNavGroupKey(group: string): string {
  const key = group
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return key || "general";
}

export function normalizeSidebarHiddenGroups(
  hiddenGroups: readonly string[],
): string[] {
  const seen = new Set<string>();
  const normalized: string[] = [];

  for (const group of hiddenGroups) {
    const key = group.trim().toLowerCase();
    if (!SIDEBAR_GROUP_KEY_PATTERN.test(key) || seen.has(key)) continue;
    seen.add(key);
    normalized.push(key);
  }

  return normalized;
}

function normalizeSidebarPreferences(
  preferences: Partial<SidebarPreferences> | null | undefined,
): SidebarPreferences {
  return {
    hiddenGroups: Array.isArray(preferences?.hiddenGroups)
      ? normalizeSidebarHiddenGroups(preferences.hiddenGroups)
      : [],
  };
}

export async function getSidebarPreferences(): Promise<SidebarPreferences> {
  const preferences = await apiClient.get<SidebarPreferences>(
    SIDEBAR_PREFERENCES_ENDPOINT,
  );
  return normalizeSidebarPreferences(preferences);
}

export async function updateSidebarPreferences(
  hiddenGroups: readonly string[],
): Promise<SidebarPreferences> {
  const preferences = await apiClient.patch<SidebarPreferences>(
    SIDEBAR_PREFERENCES_ENDPOINT,
    { hiddenGroups: normalizeSidebarHiddenGroups(hiddenGroups) },
  );
  return normalizeSidebarPreferences(preferences);
}
